import { Routes, RouterModule } from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';

// noinspection TypeScriptValidateTypes
// export function loadChildren(path) { return System.import(path); };

import { AuthGuard, PureGuard } from '../guards';
import { SetPasswordModule } from './set-password/set-password.module';
import { FaceAnalyticsModule } from './face-analytics/face-analytics.module';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: 'app/pages/login/login.module#LoginModule',
    canActivate: [PureGuard]
  },
  {
    path: 'no-permission',
    loadChildren: 'app/pages/no-permission/no-permission.module#NoPermissionModule'
  },
  {
    path: 'forgot-password',
    loadChildren: 'app/pages/forgot-password/forgot-password.module#ForgotPasswordModule',
    canActivate: [PureGuard]
  },
  {
    path: 'logout',
    loadChildren: 'app/pages/login/login.module#LoginModule',
    data: { logout: true }
  },
  {
    path: 'register',
    loadChildren: 'app/pages/register/register.module#RegisterModule',
    canActivate: [PureGuard]
  },
  {
    path: 'set-password/:token',
    loadChildren: 'app/pages/set-password/set-password.module#SetPasswordModule',
    canActivate: [PureGuard]
  },
  {
    path: 'version',
    loadChildren: 'app/pages/version/version.module#VersionModule'
  },
  {
    path: 'pages',
    component: Pages,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'test', loadChildren: './test/test.module#TestModule' },
      { path: '', loadChildren: './general/general.module#GeneralModule' },
      { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule', data: { resource: ['DASH'] } },
      { path: 'qmsdashboard', loadChildren: './qmsdashboard/dashboard.module#QMSDashboardModule', data: { resource: ['QMS'] } },
      { path: 'notifications', loadChildren: './notifications/notifications.module#NotificationsModule' },
      { path: 'admin', loadChildren: './admin/admin.module#AdminModule', data: { resource: ['CUSTOMER_SETUP', 'USER', 'ROLE'] } },
      { path: 'cms', loadChildren: './cms/cms.module#CmsModule', data: { resource: ['CONTENT', 'LAYOUT', 'LAYOUT_GROUP', 'TEMPLATE', 'PLANOGRAM', 'LOCATION'] } },
      { path: 'device', loadChildren: './device/device.module#DeviceModule', data: { resource: ['DEVICE_ONBOARD', 'DEVICE', 'DEVICE_GROUP', 'CUSTOMER_DEVICE_CONFIG', 'DEVICE_SETTING'] } },
      { path: 'reports', loadChildren: './reports/reports.module#ReportsModule', data: { resource: ['REPORTS'] } },
      { path: 'car-configurator', loadChildren: './car-configurator/car-configurator.module#CarConfiguratorModule', data: { resource: ['TPA_REPORTS'] } },
      { path:'dg-dashboard', redirectTo: 'demographic-dashboard/demographic-dashboard', pathMatch: 'full' },
      { path:'demographic-dashboard', loadChildren:'./face-analytics/face-analytics.module#FaceAnalyticsModule'},
      { path:'fa-reports', loadChildren:'./reports/reports.module#ReportsModule'}
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts